import { useCallback } from 'react';
import { useLoginContext } from '../reducer/useLogin';
import { requestOtp } from '../../rest-api/request';
import { isAllowedToResendOtp } from '../../common/otpAbuseHelper';

export const useResendOTP = () => {
  const [state, dispatch] = useLoginContext();
  return useCallback(async () => {
    const data = state.data;
    if (data.type !== 'VERIFYING_OTP' || state.loading) {
      return;
    }
    dispatch('LOADING');
    try {
      if (isAllowedToResendOtp()) {
        await requestOtp(data.phoneNumber);
        dispatch({ ...data, error: undefined });
      } else {
        dispatch({
          ...data,
          error: 'rate-limited',
        });
      }
    } catch (exception) {
      dispatch({
        ...data,
        error: 'generic-error',
      });
    }
  }, [state, dispatch]);
};
